
  var _styles = {
  "periodic-reward-claim-container": {
    "display": "flex",
    "flexDirection": "column",
    "width": "10rem",
    "position": "relative",
    "alignItems": "center"
  },
  "rewards-list-open-btn": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "rewards-list-open-btn-text": {
    "fontWeight": "400",
    "opacity": 0.6,
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem"
  },
  "title-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "marginBottom": "0.21333rem",
    "zIndex": 1
  },
  "title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem"
  },
  "claim-container": {
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "borderRadius": "0.48rem",
    "backgroundColor": "rgb(255,255,255)",
    "paddingTop": "0.21333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.32rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2', 'url("https://s3.meituan.net/static-prod01/com.sankuai.hoteltripcommon.mktfe.toubleshooting-files/MTfin-Regular3.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
    var fontFace2 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace2);
    
  }
    


  module.exports = _styles;
  